import { useSession } from '@side/next-auth/react';
import { useReferral } from '@/common/hooks/referrals/useReferral';
import { useOptionalRouteParam } from '@/common/hooks/useOptionalRouteParam';
import { getFullName } from '@/common/utils/person';

export function useReferralSummaryText() {
  const referralId = useOptionalRouteParam('referralId');
  const { interaction, loading } = useReferral(referralId);
  const { data: session } = useSession();

  // Return early if interaction or session data is missing
  if (!interaction || !session) return { loading };

  const { referringAgent, transactingAgent, referralType } = interaction;
  const { id: userId, legacyExternalId } = session.user;

  // Determine if user is counterparty agent
  const counterpartyAgentId =
    referralType === 'sending'
      ? transactingAgent?.userId
      : referringAgent?.userId;

  const isCounterpartyAgent =
    userId === counterpartyAgentId || legacyExternalId === counterpartyAgentId;

  const transactingAgentFullName = getFullName(
    transactingAgent?.firstName,
    transactingAgent?.lastName,
  );
  const referringAgentFullName = getFullName(
    referringAgent?.firstName,
    referringAgent?.lastName,
  );

  if (isCounterpartyAgent) {
    if (referralType === 'sending') {
      return {
        summary: `Referral from ${referringAgentFullName}`,
        agentName: referringAgentFullName,
        loading,
      };
    }

    return {
      summary: `Referral to ${transactingAgentFullName}`,
      agentName: transactingAgentFullName,
      loading,
    };
  }

  if (referralType === 'sending') {
    return {
      summary: `Referral to ${transactingAgentFullName}`,
      agentName: transactingAgentFullName,
      loading,
    };
  }

  return {
    summary: `Referral from ${referringAgentFullName}`,
    agentName: referringAgentFullName,
    loading,
  };
}
